import axios from 'axios';
import { decompressData } from '/src/utils/decompressData';

const baseUrl = import.meta.env.VITE_GEO_BOUNDARY_BASE_URL;

export const fetchCountyBoundaries = async (fips) => {
    console.log('Fetching county boundary for FIPS:', fips);
    try {
        const response = await axios.get(
            `${baseUrl}/us-county-boundaries/records?select=*&where=geoid='${fips}'`
        );
        console.log('County boundary response:', response.data);
        if (response.data && response.data.results.length > 0) {
            const countyInfo = response.data.results[0];
            console.log('County info:', countyInfo);
            return {
                geometry: countyInfo
            };
        }
        return null;
    } catch (error) {
        console.error('Error fetching county boundary data:', error);
        throw error;
    }
};
